import React, { useState, useEffect } from 'react';
import { ButtonLink } from './ButtonLink';
import { Link } from 'react-router-dom';
import { FcSms, FcCallTransfer  } from "react-icons/fc";
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            <img src='../images/logo.jpg' width='120px' height='50px'/>
            
            {/* <i class='fab fa-typo3' /> */}
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/services'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Services
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/about'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                About
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/pricelist'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Pricing
              </Link>
              </li>
              <li className='nav-item'>
              <Link
                to='/contact'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
              </li>
              

          </ul>

          {/* {button && <ButtonLink buttonStyle='btn--outline'><span style={{ "font-size": "13px"}}>Call Us <FcCallTransfer/> +91-9794324845<br/>Email us<FcSms /> help_fcs@fcsonline.in</span></ButtonLink>} */}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
